import React from 'react';
import { Shimmer } from '../../../../../CommonComponents/OPL/Shimmer/Shimmer';

export const SearchActionsLoading = () => {
  return <Shimmer width={320} height={36} ml="8" />;
};
